import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useUserState, useUserDispatch } from "../../context/user";
import { loginUser } from "../../context/user/user.actions";
import { sendPasswordResetRequest } from "../../auth/auth.js";
import ForgotPasswordModal from "./components/ForgotPasswordModal.js";
import styles from "./Login.module.css";

function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Global State Context
  const { error, loading } = useUserState();
  const dispatch = useUserDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const next = new URLSearchParams(location.search).get("next");

  const handleSubmit = (e) => {
    e.preventDefault();
    loginUser(dispatch, navigate, username, password, next);
  };

  const handleForgotPassword = async (email) => {
    try {
      const response = await sendPasswordResetRequest(email);
      setIsModalOpen(false);
      alert(response.data.success);
      navigate("/password_change");
    } catch (error) {
      return error;
    }
  };

  return (
    <div className={styles.pageContainer}>
      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <h1>EWI DELs</h1>
        {/* Only show error if it exists and is not null */}
        {error && (
          <div className={styles.errorMessage} data-testid="error-message">
            {error}
          </div>
        )}

        <label htmlFor="username">Username/Email:</label>
        <input
          type="text"
          id="username"
          name="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoComplete="username"
          data-testid="username-input"
        />

        <label htmlFor="password">Password:</label>
        <div className={styles.passwordInputContainer}>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            data-testid="password-input"
          />
          <FaEye
            className={`${styles.passwordToggleIcon} ${
              showPassword ? styles.hidden : ""
            }`}
            onClick={() => setShowPassword(true)}
            data-testid="show-password-icon"
          />
          <FaEyeSlash
            className={`${styles.passwordToggleIcon} ${
              !showPassword ? styles.hidden : ""
            }`}
            onClick={() => setShowPassword(false)}
            data-testid="hide-password-icon"
          />
        </div>

        <div className={styles.buttonContainer}>
          {/* Disable the button while a login is in progress. */}
          <button
            type="submit"
            className={styles.loginButton}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
          <button
            type="button"
            className={styles.forgotPasswordButton}
            onClick={() => setIsModalOpen(true)}
            data-testid="forgot-password-button"
          >
            Forgot Password?
          </button>
        </div>
      </form>
      <ForgotPasswordModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleForgotPassword}
      />
    </div>
  );
}

export default LoginForm;
